import React from "react";
import { motion } from "framer-motion";
import {
  FaSortAlphaDown,
  FaSortAlphaUp,
  FaSortAmountDown,
  FaSortAmountUp,
} from "react-icons/fa";

function SortModal({ sortProjects, closeModal, sortType }) {
  return (
    <motion.div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        className="bg-white rounded-lg p-6"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <h2 className="text-lg font-bold mb-4">Sort Projects</h2>
        <div className="flex flex-col justify-between mb-4 p-4 gap-10">
          <motion.button
            className={`flex items-center justify-center px-4 py-2 rounded-md ${
              sortType === "az" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
            onClick={() => sortProjects("az")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            A-Z <FaSortAlphaDown className="ml-1" />
          </motion.button>
          <motion.button
            className={`flex items-center justify-center px-4 py-2 rounded-md ${
              sortType === "za" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
            onClick={() => sortProjects("za")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Z-A <FaSortAlphaUp className="ml-1" />
          </motion.button>
          <motion.button
            className={`flex items-center justify-center px-4 py-2 rounded-md ${
              sortType === "newest" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
            onClick={() => sortProjects("newest")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Newest <FaSortAmountDown className="ml-1" />
          </motion.button>
          <motion.button
            className={`flex items-center justify-center px-4 py-2 rounded-md ${
              sortType === "oldest" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
            onClick={() => sortProjects("oldest")}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Oldest <FaSortAmountUp className="ml-1" />
          </motion.button>
        </div>
        <motion.button
          className="bg-red-500 text-white px-4 py-2 rounded-md"
          onClick={closeModal}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Close
        </motion.button>
      </motion.div>
    </motion.div>
  );
}
export default SortModal;
